var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QField',_vm._b({class:[
    'sai-input',
    { 'sai-input--large': _vm.large, 'sai-input--extra-large': _vm.extraLarge }
  ],attrs:{"hide-bottom-space":_vm.hideBottomSpace,"rounded":_vm.rounded,"borderless":"","error":_vm.error,"no-error-icon":""}},'QField',_vm.$attrs,false),[_c('input',_vm._g({directives:[{name:"money",rawName:"v-money",value:(_vm.vMoney),expression:"vMoney"}],class:[
      `q-field__native q-placeholder text-${_vm.error ? 'negative' : _vm.textColor}`,
      { 'text-center': _vm.textCenter }
    ],domProps:{"value":_vm.value},on:{"input":_vm.updateInput}},_vm.boundListeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }